import React from "react";
import styled from "styled-components";
const image1 = require("../../assets/svg/Services/net.svg");
const image2 = require("../../assets/svg/Services/optimum.png");
const image3 = require("../../assets/svg/Services/consult.png");
const image4 = require("../../assets/svg/Services/software.png");
const image5 = require("../../assets/svg/Services/renew.png");

const icons = { roller: image1, monitor: image2, browser: image3, printer: image4, renew: image5 };

export default function ServiceBox({ icon, title, subtitle, index }) {
  return (
    <Card>
      <CardTop><IconWrap><img src={icons[icon] || image5} alt="" /></IconWrap><Index>{String(index).padStart(2, "0")}</Index></CardTop>
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </Card>
  );
}

const Card = styled.article`
  height: 100%; padding: 30px; border: 1px solid #e3e7e5; border-radius: 24px; background: #fff;
  transition: .3s ease;
  &:hover { transform: translateY(-6px); border-color: rgba(10,146,80,.42); box-shadow: 0 22px 46px rgba(23,21,47,.1); }
  h2 { margin: 25px 0 13px; color: #17152f; font-size: 1.2rem; line-height: 1.35; letter-spacing: -.025em; }
  p { color: #646979; font-size: .82rem; line-height: 1.75; }
`;
const CardTop = styled.div`display: flex; justify-content: space-between; align-items: flex-start;`;
const IconWrap = styled.div`width: 58px; height: 58px; display: grid; place-items: center; border-radius: 17px; background: #eef7f1; img { width: 34px; height: 34px; object-fit: contain; }`;
const Index = styled.span`color: #cbcfd0; font-size: .68rem; font-weight: 800; letter-spacing: .1em;`;
